import { Input } from 'antd';
import FormField from 'components/FormField';
import { FV } from './share';
import { useTranslate } from '@tolgee/react';
import { DisabledProps } from 'views/Aide/Scenario/TaskForm/share';
import { useHelpContext } from '../HelpContext';
import { InlineHelp } from '../Help';

function Name({ disabled }: DisabledProps) {
  const { t } = useTranslate();

  const label = t('act_field_name');

  const placeholder = t('department.请输入x', { x: label.toLowerCase() });

  const {
    stepState: [, setHelpStep],
  } = useHelpContext();

  return (
    <FormField<FV['activityName']>
      name="activityName"
      required
      label={label}
      validate={(value) => (!value || !value.trim() ? placeholder : undefined)}
    >
      {({ field }) => {
        const input = (
          <Input
            showCount
            disabled={disabled}
            maxLength={50}
            placeholder={placeholder}
            onFocus={() => setHelpStep('活动名称')}
            {...field}
          />
        );

        return <InlineHelp step="活动名称">{input}</InlineHelp>;
      }}
    </FormField>
  );
}

export default Name;
